<template>
  <div class="detail-display center-vertical">
    <div
      v-for="(detail, detailIndex) in details"
      :key="detailIndex"
      class="capsule-text capsule-text-right"
      :class="[ { active } ]" :style="`margin-top:${detail.offset}rem`"
    >
      <h1 :class="[ 'font-medium', 'text-size-43', detail['heading-classes'] ]" v-html="detail.heading"></h1>
      <p
        :class="[ 'font-regular', detail['text-classes'], 'line-height-large', 'fg-white' ]"
        v-html="detail.text"
      ></p>
      <DefaultButton
        v-if="detail.button"
        :label="$getString('FOLLOW_PATHWAY_BUTTON_LABEL')"
        buttonClass="auto centered text-uppercase button-primary mt-6"
        @pressed="followPathway"
      />
      <div
        v-for="line in detail.lines"
        :key="line"
        :class="[ 'lines', `lines-${index}-${detailIndex}-${line}` ]"
      >
        <div class="line line-root node-start">
          <div class="line line-tail node-end"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultButton from './DefaultButton'

export default {
  name: 'DetailDisplay',
  components: {
    DefaultButton,
  },
  props: {
    detail: {
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      active: false,
      animate: false,
      details: [],
    }
  },
  methods: {
    followPathway() {
      this.$emit('action', { type: 'followPathway', data: this.index });
    }
  },
  mounted() {
    this.details = Array.isArray(this.detail) ? this.detail : [ this.detail ];
    setTimeout(() => this.active = true, 500);
    this.animate = true;
  }
}
</script>
